import React, { ComponentProps, useState } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { Download } from '../../../_lib/components/Download';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useModalContext } from '../../../components/organisms/ModalDialog/ModalContext';
import { useDelayed } from '../../../hooks/useDelayed';
import LiveRegion from '../../../components/atoms/LiveRegion/LiveRegion';
import { StatusInfoLoading } from '../../../_lib/components/StatusInfo/StatusInfoLoading';

type TicketBookingExportCsvProps = {
  approximateFileSize: number;
  fileNameIncludingExtension: string;
  url: string;
};

function TicketBookingExportCsv({ approximateFileSize, fileNameIncludingExtension, url }: TicketBookingExportCsvProps) {
  const { t } = useSonTranslation('TicketBooking');
  const { closeModal } = useModalContext();
  const delayedCloseModal = useDelayed(closeModal);

  const [downloadStarted, setDownloadStarted] = useState(false);

  const close = () => {
    setDownloadStarted(true);
    delayedCloseModal();
  };

  return (
    <div className="ticket-booking__export-csv-container">
      <div className="ticket-booking__export-csv-download">
        <Download
          url={url}
          fileName={fileNameIncludingExtension}
          fileExtension="csv"
          mimeType="text/csv"
          fileSizeBytes={approximateFileSize}
        />
      </div>
      <div className="ticket-booking__export-csv-button">
        <Btn
          href={url}
          routing={false}
          modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_YES]}
          onClick={close}
        >
          {t('exportCsv.downloadFile')}
        </Btn>
      </div>
      <LiveRegion htmlTag="div" invisible={false} ariaAtomic>
        {downloadStarted && <StatusInfoLoading modifier="right" message={t('exportCsv.downloadStarted')} />}
      </LiveRegion>
    </div>
  );
}

export const TicketBookingExportCsvView = asFetchableView(TicketBookingExportCsv);
export type TicketBookingExportCsvView = ComponentProps<typeof TicketBookingExportCsvView>;
